import { useContext, useEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import State from "../../../../../../context";
import Overlay from "../../../../../../atom/Overlay";
import OverlayPdf from "../../../../pdf/component/OverlayPdf";
import ReportPdfContentHolder from "../../../../pdf/template/ReportPdfContentHolder";
import ViewProposalGoals from "./component/ViewProposalGoals";
import ViewProposalGoal from "./component/ViewProposalGoal";

import StylesContainer from "./style";

import { LIST_PDF_PAGE_PROPOSAL_ONEASCENT } from "../../../../constant";

import { isOrganizationOneascent } from "../../../../../../utils/helper/specialized";
import { getHtml2pdfPromiseList } from "../../../../../../utils/pdf";
import { getLatestSavedProposalId } from "./helper";

const PageGoals = () => {
  const [state] = useContext(State);
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const isModeDownloadPdf = searchParams.get("modeDownloadPdf") === "true";

  const isModeNewProposal = searchParams.get("modeNewProposal") === "true";

  useEffect(() => {
    if (state.loading || state.showOverlay) return;

    if (isModeDownloadPdf) {
      const productsMap = state.preferences?.valueMap?.productMap;

      if (!productsMap) {
        state.showWarning("No saved goals");
        return;
      }

      const latestSavedGoalId = getLatestSavedProposalId(productsMap);

      if (!latestSavedGoalId) {
        state.showWarning("No saved goals");
        return;
      }

      state.setKeyValue("activeGoal", latestSavedGoalId);
      handleGeneratePdf();
    }
  }, [state.loading, state.showOverlay, searchParams]);

  useEffect(() => {
    state.setKeyValue("viewMode", "goals");
  }, [location]);

  useEffect(() => {
    if (state.runPdfGenerator && !state.loadingPdfContent) {
      state.setKeyValue("runPdfGenerator", false);

      // extra time, to render all the charts and images, before making snapshots
      setTimeout(() => {
        getHtml2pdfPromiseList(LIST_PDF_PAGE_PROPOSAL_ONEASCENT)
          .save("OneAscent PDF")
          .then(() => state.closeAfterPdfGenerated && window.close())
          .catch(error => state.showError(error))
          .finally(() => state.setKeyValue("showPdfGeneratorOverlay", false));
      }, 3000);
    }
  }, [state]);

  const handleAddGoal = () => {
    state.setKeyValue("activeGoal", undefined);
    state.setKeyValue("viewMode", "goal");
  };

  const handleCloseGoal = () => {
    state.setKeyValue("activeGoal", undefined);
    state.setKeyValue("viewMode", "goals");
  };

  const handleCopyGoal = activeGoal => {
    state.setKeyValue("activeGoal", activeGoal);
    state.setKeyValue("viewMode", "goal");

    setTimeout(() => {
      state.setKeyValue("activeGoal", undefined);
    }, 1000);
  };

  const handleGeneratePdf = () => {
    state.setKeyValue("showPdfGeneratorOverlay", true);
    state.setKeyValue("runPdfGenerator", true);
  };

  const handleViewGoal = goalId => {
    state.setKeyValue("activeGoal", goalId);
    state.setKeyValue("viewMode", "goal");
  };

  return (
    <Overlay loading={state.loading || state.viewMode === "pdf"}>
      <StylesContainer>
        {state.getPreferenceValue("productMap") &&
        state.viewMode === "goals" &&
        !isModeNewProposal ? (
          <ViewProposalGoals
            handleAddGoal={handleAddGoal}
            handleCopyGoal={handleCopyGoal}
            handleGeneratePdf={handleGeneratePdf}
            handleViewGoal={handleViewGoal}
            productsList={state.productsList}
          />
        ) : (
          <ViewProposalGoal
            activeGoal={state.activeGoal}
            handleCloseGoal={handleCloseGoal}
            handleGeneratePdf={handleGeneratePdf}
            productsList={state.productsList}
          />
        )}

        {isOrganizationOneascent(state.organization?.name) && (
          <>
            <ReportPdfContentHolder />
            <OverlayPdf show={state.showPdfGeneratorOverlay} />
          </>
        )}
      </StylesContainer>
    </Overlay>
  );
};

export default PageGoals;
